import React from 'react';
import { Badge } from 'react-bootstrap';

import ComprobanteTicketStatus from '../../enum/ComprobanteTicketStatus';

const TimbradoMasivoTicketsRenderStatus = ({item}) => {
  let variant = 'light';

  const status = ComprobanteTicketStatus.search(item.status) || ComprobanteTicketStatus.undefined();

  if (status.isSuccess()) {
    variant = 'success'
  } else if (status.isCancelled() || status.isError() || status.isFailed()) {
    variant = 'danger'
  } else if (!status.isPending()) {
    variant = 'info';
  }

  return <Badge variant={ variant }>{ status.getName() }</Badge>
}

export default TimbradoMasivoTicketsRenderStatus;